import { ChangeLogEntityType, useGetChangeLogByEntity } from '../../../../../api/created/changeLog.ts';
import type { MedicationDto } from '../../../../../api/generated/model';
import { useUsers } from '../../../../../api/created/users.ts';
import { ChangeHistoryModal } from '../../../../../components/history/ChangeHistoryModal.tsx';
import { mapChangeLogEntriesToMedicationHistory } from './medicationHistory.ts';

type MedicationHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  medication: MedicationDto | null;
};

export function MedicationHistoryModal({ open, onClose, medication }: MedicationHistoryModalProps) {
  const medicationId = medication?.id ?? undefined;
  const { data: changeLogEntries = [], isLoading } = useGetChangeLogByEntity(
    ChangeLogEntityType.MEDICATION,
    medicationId,
    {
      enabled: open && !!medicationId,
    },
  );
  const { data: users = [] } = useUsers({ enabled: open && !!medicationId });
  const historyEntries = mapChangeLogEntriesToMedicationHistory(changeLogEntries, { users });
  const medicationName = medication?.name || 'Medikament';

  return (
    <ChangeHistoryModal
      open={open}
      onClose={onClose}
      title={`Verlauf – ${medicationName}`}
      subject="Das Medikament"
      entityName={medicationName}
      entries={historyEntries.map((entry) => ({
        ...entry,
        changedBy: entry.changedByName,
      }))}
      isLoading={isLoading}
    />
  );
}
